import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e2419c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 px-0" }
const _hoisted_3 = { class: "facilities-container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12 col-lg-7 order-2 order-lg-1 d-flex justify-content-center" }
const _hoisted_6 = { class: "p-3 p-lg-5 py-5 content-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Facilities", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-3 mb-4" }, null, -1))
const _hoisted_9 = { class: "content" }
const _hoisted_10 = {
  key: 0,
  class: "row"
}
const _hoisted_11 = {
  key: 1,
  class: "no-info"
}
const _hoisted_12 = { class: "col-12 col-lg-5 order-1 order-lg-2" }
const _hoisted_13 = { class: "image-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageContainer = _resolveComponent("ImageContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                (_ctx.facilities.length)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.facilities, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: item,
                          class: "col-6 col-xxl-4"
                        }, _toDisplayString(item), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.facilities.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, " No information available. "))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_ImageContainer, { imageUrl: _ctx.imageUrl }, null, 8, ["imageUrl"])
            ])
          ])
        ])
      ])
    ])
  ]))
}